module.exports = __webpack_public_path__ + "img/bell-slash.5d64e413.svg";